import { Box, styled, SxProps, Typography, useTheme } from "@mui/material";
import { StyleguideSavioColors, StyleguideSavioFonts, themeSettings } from "../../../configuration/themeSettings";

export const SalesConditionLabelStyled = styled(Typography, {
    label: "OrderOffer-SalesConditionLabelStyled",
})(({ theme }) => ({
    fontWeight: StyleguideSavioFonts.bold,
    marginTop: "3px",
    marginRight: "7px",
    color: StyleguideSavioColors.text.black,
    fontSize: 12,
    textTransform: 'uppercase',
    padding: 3,
    '&:after': {
        content: '":"',
    }
}));

export const SalesConditionValueStyled = styled(Typography, {
    label: "OrderOffer-SalesConditionValueStyled",
})(({ theme }) => ({
    marginTop: "3px",
    marginRight: "7px",
    fontSize: 12,
    padding: 3
}));

export const SalesConditionContainerStyled = styled(Typography, {
    label: "OrderOffer-SalesConditionContainerStyled",
})(({ theme }) => ({
    display: "flex",
    flexDirection: "column",
    '>p': { display: 'none', },
    '*': {
        fontSize: 14,
    }
}));
;

export const SalesConditionBoxStyled = styled(Box, {
    label: "OrderOffer-SalesConditionBoxStyled",
})(({ theme }) => ({
    display: "flex",
    flexDirection: "row",
    height: 20,
}));

export const useClasses = () => {
    const theme = useTheme();
    const classes = {
        skeleton: {
            'tr': {
                height: 24,
            }
        } as SxProps,
    };
    return classes;
};
